import { createContext, useContext, type ReactNode } from "react";

type MDSFloatingPortalRoot = HTMLElement | null;

const MDSFloatingPortalRootContext = createContext<MDSFloatingPortalRoot | undefined>(undefined);

/**
 * React Aria makes DOM outside an open modal inert. Legacy Floating UI menus
 * use this root to stay inside the modal's interactive subtree.
 */
export const MDSFloatingPortalRootProvider = ({
  children,
  portalRoot,
}: {
  children: ReactNode;
  portalRoot: MDSFloatingPortalRoot;
}) => {
  return (
    <MDSFloatingPortalRootContext.Provider value={portalRoot}>
      {children}
    </MDSFloatingPortalRootContext.Provider>
  );
};

export const useMDSFloatingPortalRoot = () => useContext(MDSFloatingPortalRootContext);
